import React from 'react';
import { BookOpen } from 'lucide-react';
export function Volumes() {
  const volumes = [{
    number: '1',
    title: 'Rabietas: Entiende lo que tu hijo intenta decirte',
    description: 'Aprendé a comprender qué ocurre realmente detrás de cada berrinche y cómo responder sin empeorar la situación.',
    image: 'https://cdn.magicpatterns.com/uploads/4HHpWaMUizkd12ov9A3chG/photo_2026-07-03_15-19-20.jpg'
  }, {
    number: '2',
    title: 'Límites sin gritos ni castigos',
    description: 'Descubrí cómo lograr que tu hijo coopere desde el respeto, manteniendo la autoridad sin recurrir al miedo.',
    image: 'https://cdn.magicpatterns.com/uploads/87AYKejHVZkPTdQpFX5b4s/photo_2026-07-03_15-19-10.jpg'
  }, {
    number: '3',
    title: 'Inteligencia emocional para niños',
    description: 'Enseñale a reconocer, expresar y gestionar sus emociones desde pequeños.',
    image: 'https://cdn.magicpatterns.com/uploads/pkvRGVyzCoArB9RUL1mtYX/photo_2026-07-03_15-19-10_(2).jpg'
  }, {
    number: '4',
    title: 'Guía para padres',
    description: 'Herramientas prácticas para afrontar los desafíos diarios de la crianza con mayor seguridad y confianza.',
    image: 'https://cdn.magicpatterns.com/uploads/wcaz4wraXNgQ4KvBTUemHo/photo_2026-07-03_15-19-11.jpg'
  }];
  return <section className="py-16 px-4 md:px-8 bg-white" data-id="element-96">
      <div className="max-w-5xl mx-auto" data-id="element-97">
        <div className="text-center mb-12" data-id="element-98">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-textDark" data-id="element-99">
            ¿Qué vas a encontrar dentro?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-100">
          {volumes.map((vol, index) => <div key={index} className="bg-brand-bg rounded-2xl p-6 border border-brand-sage/20 hover:shadow-md transition-shadow relative overflow-hidden flex flex-col sm:flex-row gap-5" data-id="element-101">
              <div className="absolute top-0 left-0 w-2 h-full bg-brand-sage" data-id="element-102"></div>
              <img src={vol.image} alt={`Portada del ${vol.title}`} className="w-32 h-auto self-center sm:self-start shrink-0 mix-blend-multiply" data-id="element-103" />
              <div data-id="element-104">
                <div className="flex items-center space-x-3 mb-3" data-id="element-105">
                  <div className="bg-brand-sage text-white font-bold px-3 py-1 rounded-lg text-sm" data-id="element-106">
                    Volumen {vol.number}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-brand-textDark mb-3 flex items-start" data-id="element-107">
                  <BookOpen className="w-5 h-5 text-brand-sageDark mr-2 shrink-0 mt-1" data-id="element-108" />
                  {vol.title}
                </h3>
                <p className="text-brand-text leading-relaxed" data-id="element-109">
                  {vol.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}